'use client'

import * as React from 'react'
export interface CreateProductProjectDialogContextModel {
  isOpen: boolean
  clubhouseSlug?: string
  openDialog: (clubhouseSlug?: string) => void
  closeDialog: () => void
}

const CreateProductProjectDialogContext =
  React.createContext<CreateProductProjectDialogContextModel>(null!)

export const CreateProductProjectDialogProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [clubhouseSlug, setClubhouseSlug] = React.useState<string | undefined>()

  const openDialog = (clubhouseSlug?: string) => {
    setIsOpen(true)
    setClubhouseSlug(clubhouseSlug)
  }

  const closeDialog = () => {
    setIsOpen(false)
    setClubhouseSlug(undefined)
  }

  return (
    <CreateProductProjectDialogContext.Provider
      value={{ isOpen, closeDialog, openDialog, clubhouseSlug }}
    >
      {children}
    </CreateProductProjectDialogContext.Provider>
  )
}

export const useCreateProductProjectDialog = () => {
  const context = React.useContext(CreateProductProjectDialogContext)

  if (context === undefined) {
    throw new Error(
      'useCreateProductProjectDialog must be used within a CreateProductProjectDialogProvider',
    )
  }

  return context
}
